import EA from 'helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.config({ nullTargetWarn: false });

const SECTION_SELECTOR = '[data-method="fadeAnim"]';

const DEFAULTS = {
    y: 30,
    duration: 0.6,
    stagger: 0.2,
    delay: 0,
    start: '0 70%',
    ease: 'power3.inOut'
};

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const toNumber = (value, fallback) => {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
};

const getTargets = ($section) =>
    Array.from($section.querySelectorAll('.fade'))
        .filter(($el) => $el.closest(SECTION_SELECTOR) === $section);

export default EA.Methods.fadeAnim = ($this) => {
    const targets = getTargets($this);

    if (!targets.length) {
        return null;
    }

    const { fadeMode = 'scroll', fadeStart, fadeDuration, fadeStagger, fadeDelay } = $this.dataset;

    if (prefersReducedMotion) {
        gsap.set(targets, { clearProps: 'all' });
        return null;
    }

    const vars = {
        y: DEFAULTS.y,
        autoAlpha: 0,
        duration: toNumber(fadeDuration, DEFAULTS.duration),
        stagger: toNumber(fadeStagger, DEFAULTS.stagger),
        delay: toNumber(fadeDelay, DEFAULTS.delay),
        ease: DEFAULTS.ease,
        clearProps: 'all'
    };

    if (fadeMode === 'load') {
        return gsap.from(targets, vars);
    }

    return gsap.from(targets, {
        ...vars,
        scrollTrigger: {
            trigger: $this,
            start: fadeStart || DEFAULTS.start,
            once: true
        }
    });
};
